// fundUsage — fund used, win rate and return % for any group of ledger trades (God 2026-10-06 ~19:12).
// Same definitions as the Funds & Margin "Fund Usage & Return" tab (modules/fund_usage_report.py):
//   fund used = the largest capitalUsed of one trade in the group (a cell holds one position at a time);
//               for a bot = the sum over its symbol x TF cells (they can all be open together)
//   win %     = WIN / (WIN + LOSS + BREAKEVEN)
//   return %  = net P&L (ALL-INCLUSIVE, the ledger's netPnl) / fund used
export type Usage = { fund: number; win: number | null; ret: number | null; closed: number };

const CLOSED = new Set(['WIN', 'LOSS', 'BREAKEVEN']);

export function usageOf(trades: any[], net: number): Usage {
  let fund = 0, wins = 0, closed = 0;
  for (const t of trades || []) {
    if (t?.status === 'VOID') continue;
    const c = Number(t?.capitalUsed) || 0;
    if (c > fund) fund = c;
    if (CLOSED.has(t?.status)) { closed += 1; if (t.status === 'WIN') wins += 1; }
  }
  return { fund, closed, win: closed ? (100 * wins) / closed : null, ret: fund ? (100 * net) / fund : null };
}

export function usageOfCells(cells: { trades: any[]; net: number }[], net: number): Usage {
  let fund = 0, wins = 0, closed = 0;
  for (const c of cells || []) {
    const u = usageOf(c.trades, c.net);
    fund += u.fund;
    closed += u.closed;
    wins += (u.win || 0) * u.closed / 100;
  }
  return { fund, closed, win: closed ? (100 * wins) / closed : null, ret: fund ? (100 * net) / fund : null };
}

export const inrShort = (v: number) => {
  const n = Math.abs(Number(v) || 0);
  const s = n >= 1e7 ? `${(n / 1e7).toFixed(2)}Cr` : n >= 1e5 ? `${(n / 1e5).toFixed(2)}L` : n >= 1e3 ? `${(n / 1e3).toFixed(1)}K` : n.toFixed(0);
  return `${v < 0 ? '−' : ''}₹${s}`;
};
export const pctTxt = (v: number | null) => (v === null || !Number.isFinite(v) ? '—' : `${v > 0 ? '+' : ''}${v.toFixed(2)}%`);
export const pctCol = (v: number | null) => (v === null ? '#64748b' : v > 0 ? '#10b981' : v < 0 ? '#f87171' : '#94a3b8');
